import './polls.less';

App.Pages.Polls = class Polls extends PF.Page
{

	static get options()
	{
		return {
			rights: {
				guest: true,
				user: true
			},
			panel: false,
			path: '/polls',
			nameRu: 'Опрос',
		};
	}

	static get template()
	{
		//language=HTML
		return /*html*/`
            <div class="page polls">
				<div class="page-content" pf="pageContent">
					<div class="row" style="margin-top: 130px;">
                        <div class="col-100" style="text-align: center;">
							<img class="logo" src="/img/Служба крови лого.svg"/>
						</div>
					</div>
					<div class="row" style="margin-top: 140px;">
                        <div class="col-100" style="text-align: center;">
							<h1>Сделайте Центр крови лучше!<br/>Пройдите опрос!</h1>
						</div>
					</div>
					<div class="row" style="margin-top: 50px;">
                        <div class="col-100" style="text-align: center;">
							<h2>Выберите опрос:</h2>
						</div>
					</div>
                    <div pf="list"></div>
				</div>
			</div>
		`;
	}

	init()
	{
		super.init();
		if (this.user === null || this.user === undefined)
		{
			app.panelState = null;
		} else
		{
			app.panelDisplay(0);
		}
		this.dom.pageContent.css('height', '100%');
		//
		this.listDetections = new PF.List({
			dom: {
				element: this.dom.list,
			},
			html: {
				header: {},
				wrapper: `<div pf="wrapper"><div class="row" pf="ul" style="justify-content: center;"></div></div>`,
				preloaderContent: ``,
			},
			searchable: false,
			modelsConfig: {
				represent: 'polls/View',
			},
			itemClass: PollsList,
		});
	}
};

class PollsList extends PF.List.Item
{
	get renderer()
	{
		//language=HTML
		return /*html*/`
		<div class="col-45 card" style="margin-right: 10px;">
			<div class="card-header blue-100">
				<h4 style="padding-left: 0;">@{model.title}</h4>
			</div>
			<div class="card-content black-100">
				<br/>
				<div class="col-100" style="text-align: center;">
					<img src="@{model.img_svg}" alt="@{model.title}"/>
				</div>
				<b>Цель опроса:</b>
				<p>@{model.description}</p>
				<button class="button" type="button" pf="buttonStart">Пройти опрос</button>
			</div>
		</div>
		`;
	}

	onRender()
	{
		super.onRender();

		this.dom.buttonStart.on("click", () =>
		{
			this.questionsPage = 'poll-questions-step';
			app.pageParams.setData('poll_id', this.model.id);
			app.pageParams.setData('return', 'polls');
			app.request('/settings/get', { target: 'questions' }, (response) =>
			{
				this.response = response;
				if (this.response.status != 'FAIL')
				{
					this.questionsPage = this.response.data;
				}
				app.pageParams.setData('type', this.questionsPage);
				console.log('/poll-questions');
				app.router.navigate('/poll-questions');
			});
		});
	}
}